var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.25V19.25C16 18.1891 15.5786 17.1717 14.8284 16.4216C14.0783 15.6714 13.0609 15.25 12 15.25H6C4.93913 15.25 3.92172 15.6714 3.17157 16.4216C2.42143 17.1717 2 18.1891 2 19.25V21.25",
    stroke: "#009CC5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25C11.2091 11.25 13 9.45914 13 7.25C13 5.04086 11.2091 3.25 9 3.25C6.79086 3.25 5 5.04086 5 7.25C5 9.45914 6.79086 11.25 9 11.25Z",
    stroke: "#009CC5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21.2499V19.2499C21.9993 18.3636 21.7044 17.5027 21.1614 16.8022C20.6184 16.1017 19.8581 15.6015 19 15.3799",
    stroke: "#009CC5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.37988C16.8604 3.60018 17.623 4.10058 18.1676 4.80219C18.7122 5.5038 19.0078 6.36671 19.0078 7.25488C19.0078 8.14305 18.7122 9.00596 18.1676 9.70757C17.623 10.4092 16.8604 10.9096 16 11.1299",
    stroke: "#009CC5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.08f0002d93fc06932b46136a946e5893.svg";
export { ForwardRef as ReactComponent };